import { Injectable } from '@angular/core';
import { APIServiceGDNN } from './api-gdnn.service';

@Injectable({
    providedIn: 'root'
})
export class BaseServiceGDNN {

    constructor(private apiService: APIServiceGDNN) {

    }

    /**
     * GET method
     * @param args[] custom parameter
     */
    public get(apiUrl: string, args: object = {}, autoShowMessage: boolean = true) {
        return this.apiService.get(apiUrl, args, autoShowMessage);
    }

    /**
     * Post
     * @param url custom url for "ADD" api (sample: /add-custom), default: "/add"
     * @param condition
     */
    public post(apiUrl: string, condition?: any) {
        return this.apiService.post(apiUrl, condition);
    }

    /**
     * Put
     * @param url custom url for "ADD" api (sample: /add-custom), default: "/add"
     * @param condition
     */
    public put(apiUrl: string, condition?: any) {
        return this.apiService.put(apiUrl, condition);
    }

    /**
     * Delete
     * @param id Id of model
     */
    public delete(apiUrl: string, args: object = {}) {
        return this.apiService.delete(apiUrl, args);
    }

    /**
     * Download file
     * @param urlPath URL reference to API (root url from current controller path, ex: user-master/export-csv => urlPath = "export-csv)"
     * @param fileName rename file for download
     * @param data form data
     */
    public downloadFile(apiUrl: string, fileName: string, data?: any, autoShowMessage: boolean = true) {
        return this.apiService.downloadFile(apiUrl, fileName, data, autoShowMessage);
    }
}
